import type { NavItem, NavLinkItem } from '../types/content';

export const mainNav: NavItem[] = [
  { label: 'Home', to: '/' },
  { label: 'About Us', to: '/about' },
  {
    label: 'Services',
    to: '/services',
    children: [
      { label: 'Executive Search', to: '/executive-search', description: 'Senior leadership and C-suite appointments' },
      { label: 'Board & NED Search', to: '/services#board-non-executive', description: 'Chairs and independent directors' },
      { label: 'Permanent Recruitment', to: '/services#permanent-recruitment', description: 'Professional and management roles' },
      { label: 'Interim & Contract', to: '/services#interim-contract', description: 'Experienced leaders, on defined terms' },
      { label: 'Talent Mapping', to: '/services#talent-mapping', description: 'Market intelligence and succession' },
      { label: 'Our Search Process', to: '/process', description: 'Ten stages from briefing to follow-up' },
      { label: 'All services', to: '/services' },
    ],
  },
  {
    label: 'Industries',
    to: '/industries',
    children: [
      { label: 'Financial Services', to: '/industries#financial-services' },
      { label: 'Technology & Digital', to: '/industries#technology' },
      { label: 'Healthcare & Life Sciences', to: '/industries#healthcare' },
      { label: 'Energy & Utilities', to: '/industries#energy' },
      { label: 'Legal, Risk & Governance', to: '/industries#legal-risk' },
      { label: 'All industries', to: '/industries' },
    ],
  },
  { label: 'Employers', to: '/employers' },
  { label: 'Find Jobs', to: '/jobs' },
  {
    label: 'Candidates',
    to: '/candidates',
    children: [
      { label: 'Career support', to: '/candidates', description: 'How we support your progression' },
      { label: 'Confidential registration', to: '/candidates#register', description: 'Share your profile discreetly' },
      { label: 'Interview preparation', to: '/candidates#resources', description: 'Guidance for every stage' },
      { label: 'Job alerts', to: '/jobs#alerts', description: 'Hear about relevant roles' },
      { label: 'Candidate FAQs', to: '/faq#candidates' },
    ],
  },
  { label: 'Insights', to: '/insights' },
  { label: 'Contact', to: '/contact' },
];

export const footerColumns: { title: string; links: NavLinkItem[] }[] = [
  {
    title: 'Company',
    links: [
      { label: 'About Us', to: '/about' },
      { label: 'Our Consultants', to: '/consultants' },
      { label: 'Search Process', to: '/process' },
      { label: 'Insights', to: '/insights' },
      { label: 'Contact', to: '/contact' },
    ],
  },
  {
    title: 'Services',
    links: [
      { label: 'Executive Search', to: '/executive-search' },
      { label: 'All Services', to: '/services' },
      { label: 'Industries', to: '/industries' },
      { label: 'Hire Talent', to: '/employers' },
    ],
  },
  {
    title: 'Candidates',
    links: [
      { label: 'Find Jobs', to: '/jobs' },
      { label: 'Career Support', to: '/candidates' },
      { label: 'Register', to: '/candidates#register' },
      { label: 'FAQs', to: '/faq' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { label: 'Privacy Policy', to: '/legal/privacy' },
      { label: 'Cookie Policy', to: '/legal/cookies' },
      { label: 'Terms of Use', to: '/legal/terms' },
      { label: 'Candidate Data Privacy', to: '/legal/candidate-privacy' },
      { label: 'Accessibility', to: '/legal/accessibility' },
    ],
  },
];
